import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { axiosBaseQuery } from "./axios";

/**
 * Extracts defined values from an object and appends them
 * to new URL search parameters
 */
export const createURLSearchParams = <T extends Record<string, any>>(
  object: T
) => {
  const url = new URLSearchParams();

  Object.keys(object).forEach(key => {
    const value = object[key as keyof T];
    if (value !== undefined && value !== null) url.set(key, String(value));
  });

  return url;
};

/**
 * The global API slice.
 *
 * For best practice we only use `createApi` once, and inject
 * endpoint slices (i.e. reports, programs etc...) using `injectEndpoints`.
 */
export const api = createApi({
  reducerPath: "api",
  baseQuery: axiosBaseQuery({ baseUrl: "" }),
  refetchOnMountOrArgChange: true,
  endpoints: () => ({}),
  tagTypes: [
    "Reports",
    "Report",
    "Programs",
    "Program",
    "Transactions",
    "PaymentDetails",
    "ManageUsers",
    "Notifications",
    "ChecklistTemplates",
    "ChecklistTemplate",
    "ProgramChecklists",
    "ProgramChecklist",
    "ResearcherPrograms",
    "ResearcherReports",
    "ChecklistItems",
    "ItemComments",
    "Delegations",
    "AdminFeedback",
    "BusinessFeedback",
    "ResearcherAssignments",
    "ProgramFeedback",
    "ProgramRuns",
    "RunChecklists",
    "RunChecklist"
  ]
});
